var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.processedAds && _vm.processedAds.length > 0
    ? _c(
        "div",
        { attrs: { id: "naver-ad-container" } },
        [
          _c("naver-ad-header", {
            attrs: {
              searchQuery: _vm.searchQuery,
              helpUrl:
                "https://help.naver.com/service/5626/contents/1419?lang=ko"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "naver_ad_content_wrapper" },
            _vm._l(_vm.processedAds, function(ad, index) {
              return _c("div", { key: index, staticClass: "box_naver_ad" }, [
                _c("div", { staticClass: "naver_ad_content" }, [
                  _c("div", { staticClass: "cont_head" }, [
                    _c("div", { staticClass: "tit_wrap" }, [
                      _c(
                        "a",
                        {
                          staticClass: "profile_wrap",
                          attrs: {
                            href: ad.clickUrl,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c("img", {
                            class: ["ico_profile", ad.profileClass],
                            attrs: { src: ad.profileImgUrl },
                            on: {
                              error: function($event) {
                                return _vm.handleImageError(
                                  $event,
                                  ".profile_wrap"
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "tit_headline",
                          attrs: {
                            href: ad.clickUrl,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [_vm._v(_vm._s(ad.siteName || ad.headline))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "txt_url",
                          attrs: {
                            href: ad.clickUrl,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [_vm._v(_vm._s(ad.cleanDisplayUrl))]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cont_body" }, [
                    _c("div", { staticClass: "cont_ad" }, [
                      _c("span", { staticClass: "tit_naver_ad" }, [
                        _c("a", {
                          attrs: {
                            href: ad.clickUrl,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.highlightKeyword(ad.headline || "")
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc_naver_ad" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: ad.clickUrl,
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "desc_text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.highlightKeyword(ad.description || "")
                                )
                              }
                            }),
                            _vm._v(" "),
                            ad.medicalNo
                              ? _c("span", { staticClass: "medical_no" }, [
                                  _vm._v(_vm._s(ad.medicalNo))
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    ad.imageExtension
                      ? _c("div", { staticClass: "cont_img" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: ad.imageExtension.clickUrl,
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "img_ad",
                                attrs: {
                                  src: ad.imageExtension.imageUrl,
                                  alt: ""
                                },
                                on: {
                                  error: function($event) {
                                    return _vm.handleImageError(
                                      $event,
                                      ".cont_img"
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            0
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }